<template>
  <div class="active-list">
    <filter-panel :data="myGroups"
                  @search="filterChange"></filter-panel>
    <data-list :table-style="{ name: 'mixture' }"
               :columns="columns"
               :data="data"
               :page="page"
               :loading="loading"
               :page-size="page.pageSize"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
  </div>
</template>

<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel";
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";
import filters from "@/mixins/filters.js";
import customer from "@/mixins/customer";
import { mapGetters } from 'vuex'
const { filters: filter } = filters;
const _typeof = (item) => typeof item == 'undefined'

const dataList = listPageCreate({
  searchConfig: {
    api: api.googleAds.activeList,
    method: "POST"
  },
  getQuery (obj, that) {
    if (_typeof(obj.serviceStaffId)) obj.serviceStaffId = that.userId
    if (!obj.startDate && !obj.endDate) {
      _.assign(obj, that.initDate);
    }
    return _.assign(obj, {
      searchType: 1,
      customerId: that.CUSTOMER || null
    });
  }
});
export default {
  name: "activeList",
  components: {
    filterPanel
  },
  props: {
    groups: Object,
    initDate: Object,
  },
  mixins: [dataList, customer],
  data () {
    const self = this;
    const columns = [
      {
        label: "授权状态",
        bind: "authorizationStatus",
        type: "mapping",
        width: "120px",
        mapType: "iconfont",
        align: "left",
        size: { fontSize: "23px" },
        parentEvent: row => {
          let status = [
            { label: "remind1", value: 0 },
            { label: "fasongchenggong", value: 1 }
          ];
          return status.find(item => row == item.value).label;
        },
        colors: row => {
          let status = [
            { label: { color: "#FCC262" }, value: 0 },
            { label: { color: "#78CE4D" }, value: 1 }
          ];
          return status.find(item => row.authorizationStatus == item.value)
            .label;
        },
        message: row => {
          let status = [
            { label: "无效", value: 0 },
            { label: "有效", value: 1 }
          ];
          return status.find(item => row.authorizationStatus == item.value)
            .label;
        }
      },
      {
        type: "custInfo",
        width: "160px",
        label: "客户",
        text: [
          {
            bind: "custName"
          },
          {
            label: "服务人员",
            bind: "serviceStaffName"
          },
          {
            label: "服务单号",
            bind: "serviceCode"
          },
          {
            label: "推广网站",
            bind: "domain",
            clickFn (text) {
              if (text) {
                if (text.includes("：")) {
                  const domain = text.split("：").pop();
                  if (domain != '-') window.open(`//${domain}`);
                }
              }
            }
          }
        ]
      },
      {
        label: "预警数",
        bind: "earlyWarningNum",
        width: "80px",
        type: "mapping",
        mapType: "text",
        align: "center",
        colors () {
          return {
            color: "#409EFF",
            "text-align": "center",
            "user-select": "none",
            cursor: "pointer"
          };
        },
        respondevent (row) {
          // self.$store.commit("SET_CUSTOMERID", row.custId);
          self.$router.push({
            name: "warningList",
            query: {
              serviceId: row.serviceId
            }
          });
        }
      },
      {
        label: "询盘数",
        align: "center",
        width: "60px",
        bind: "inquiryNum"
      },
      {
        label: "账户余额",
        bind: "balance",
        align: "center",
        width: "140px",
        type: "percentage",
        dataStyle (val) {
          return filter.rmb(val);
        }
      },
      {
        label: "询盘成本",
        type: "custInfo",
        width: "160px",
        text: [
          {
            bind: "actualInquiryCost",
            custValue (row) {
              const { actualInquiryCost } = row;
              if (actualInquiryCost == "∞") return "∞";
              return filter.rmb(row.actualInquiryCost);
            }
          },
          {
            label: "KPI",
            bind: "inquiryCost",
            custValue (row) {
              return filter.rmb(row.inquiryCost);
            }
          },
          {
            showIcon: true,
            label: "对比",
            bind: "inquiryCostComparison",
            custValue (row) {
              const { inquiryCostComparison: icc } = row;
              let text = icc > 0 ? "超出" : "减少";
              return text + "：" + filter.jojintAbs(row.inquiryCostComparison);
            },
            custIcon (row) {
              const { inquiryCostComparison } = row;
              if (!inquiryCostComparison) return false;
              let [name, color] =
                inquiryCostComparison > 0
                  ? ["shangsheng", "#f5222d"]
                  : ["xiajiang", "#52c41a"];
              return {
                name: name,
                style: {
                  color: color,
                  fontSize: "12px"
                }
              };
            }
          }
        ]
      },
      {
        label: "账户消耗",
        type: "custInfo",
        text: [
          {
            bind: "googleAdsBaseReport.exchangeRateCost",
            custValue (row) {
              if (
                row.googleAdsBaseReport &&
                row.googleAdsBaseReport.exchangeRateCost
              ) {
                return filter.rmb(row.googleAdsBaseReport.exchangeRateCost);
              }
              return "";
            }
          },
          {
            label: "平均日消耗",
            bind: "averageDailyConsumption",
            custValue (row) {
              return filter.rmb(row.averageDailyConsumption);
            }
          },
          {
            label: "预算KPI",
            bind: "kpi",
            custValue (row) {
              return filter.rmb(row.kpi);
            }
          },
          {
            showIcon: true,
            label: "对比",
            bind: "accountConsumptionComparison",
            custValue (row) {
              const { accountConsumptionComparison: acc } = row;
              let text = acc > 0 ? "超出" : "减少";
              return (
                text + "：" + filter.jojintAbs(row.accountConsumptionComparison)
              );
            },
            custIcon (row) {
              const { accountConsumptionComparison } = row;
              if (!accountConsumptionComparison) return false;
              let [name, color] =
                accountConsumptionComparison > 0
                  ? ["shangsheng", "#f5222d"]
                  : ["xiajiang", "#52c41a"];
              return {
                name: name,
                style: {
                  color: color,
                  fontSize: "12px"
                }
              };
            }
          }
        ]
      },
      {
        label: "广告效果",
        type: "custInfo",
        text: [
          {
            label: "展现数",
            bind: "googleAdsBaseReport.impressions",
            custValue (row) {
              if (
                row.googleAdsBaseReport &&
                row.googleAdsBaseReport.impressions
              ) {
                return filter.thousands(row.googleAdsBaseReport.impressions);
              }
              return "";
            }
          },
          {
            label: "点击数",
            bind: "googleAdsBaseReport.clicks",
            custValue (row) {
              if (row.googleAdsBaseReport && row.googleAdsBaseReport.clicks) {
                return filter.thousands(row.googleAdsBaseReport.clicks);
              }
              return "";
            }
          },
          {
            label: "点击率",
            bind: "googleAdsBaseReport.clickRate",
            custValue (row) {
              if (
                row.googleAdsBaseReport &&
                row.googleAdsBaseReport.clickRate
              ) {
                return filter.jojintAbs(row.googleAdsBaseReport.clickRate);
              }
              return "";
            }
          }
        ]
      },
      {
        label: "更多信息",
        type: "custInfo",
        text: [
          {
            label: "CID绑定时间",
            bind: "accountOpenTime",
            custValue (row) {
              return filter.date(row.accountOpenTime, "YYYY.MM.DD");
            }
          },
          {
            label: "订单号",
            bind: "orderCode"
          },
          {
            label: "CID",
            bind: "cid"
          }
        ]
      },
      {
        type: "btnClick",
        style: "text",
        label: "操作",
        align: "center",
        width: 100,
        bind: [
          {
            text: "详情",
            trigger (row, that) {
              that.$router.push({
                name: "serviceDefault",
                query: {
                  serviceId: row.serviceId,
                }
              });
            }
          }
        ]
      }
    ];
    return {
      columns: columns,
      myGroups: _.cloneDeep(this.groups)
    };
  },
  watch: {
    groups: {
      handler (val) {
        this.myGroups = _.cloneDeep(val);
      }
    }
  },
  computed: {
    ...mapGetters(['userId'])
  },
  activated () {
    this.query();
  },
  created () {
    this.myGroups.others.forEach(item => {
      if (item.prop == 'serviceStaffId') {
        this.$set(item, 'value', this.userId)
      }
    })
  }
};
</script>

<style lang="scss" scoped></style>
